



















































































































































































import Reflect from "reflect-metadata";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { Project } from "@/models/Project";
import { Client } from "@/models/Client";
import clientService from "@/services/ClientService";
import * as _ from "lodash";
import projectService from "../services/ProjectService";

@Component
export default class DocumentFiltersDialog extends Vue {
  @Prop({ default: "" })
  filterName!: string;

  @Prop({ default: "text" })
  filterType!: string;

  @Prop({ default: "" })
  title!: string;

  filterValue: string = "";
  filterLabel!: string;
  loading: boolean = false;
  isOpen: boolean = false;

  startDateMenu = true;
  endDateMenu = false;

  startDate: string = "";
  endDate: string = "";

  searchInput: string = "";
  /**
   * State input
   */
  selectedState: Partial<{ text: string; value: string }> = {};
  states = [
    {
      text: "Firma Pendiente",
      value: 1,
    },
    {
      text: "Pago Pendiente",
      value: 2,
    },
    {
      text: "Liberado",
      value: 3,
    },
  ];

  @Watch("selectedState")
  onContactSelect() {
    this.filterValue = this.selectedState.value as string;
    this.filterLabel = this.selectedState.text as string;
  }
  /**
   * Project input
   */
  projects: { id: number; name: string }[] = [];
  selectedProject: Partial<{ id: number; name: string }> = {};

  @Watch("selectedProject")
  onProjectSelect() {
    this.filterValue = String(this.selectedProject.id);
    this.filterLabel = this.selectedProject.name as string;
  }

  loadProjects = _.debounce(this._loadProjects, 300);

  _loadProjects() {
    this.loading = true;
    projectService
      .get({ name: this.searchInput })
      .then((response) => {
        this.projects = response.data as Project[];
      })
      .finally(() => {
        this.loading = false;
      });
  }

  /**
   * Client input
   */
  clients: Client[] = [];
  selectedClient: Partial<Client> = {};

  @Watch("selectedClient")
  onClientSelect() {
    this.filterValue = String(this.selectedClient.id);
    this.filterLabel = this.selectedClient.name as string;
  }

  loadClients = _.debounce(this._loadClients, 300);

  _loadClients() {
    this.loading = true;
    clientService
      .get({ name: this.searchInput })
      .then((response) => {
        this.clients = response.data as Client[];
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @Watch("searchInput")
  onInputChange(val: string, oldVal: string) {
    if (
      this.searchInput &&
      this.searchInput.length &&
      this.searchInput != this.filterLabel
    ) {
      if (this.filterName == "IDCLI") {
        return this.loadClients();
      }
      if (this.filterName == "IDPROJ") {
        return this.loadProjects();
      }
    }
  }

  @Watch("isOpen")
  onIsOpenChanged() {
    if (!this.isOpen) {
      this.searchInput = "";
      this.selectedClient = {};
    }
  }

  updated() {
    (this.$refs.input as HTMLInputElement).focus();
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
    this.filterValue = "";
  }

  cancelFilter() {
    this.isOpen = false;
    this.$root.$emit("filter:cancel");
  }

  applyFilter() {
    if (this.filterValue && this.filterValue != "") {
      this.$root.$emit("filter:apply", [
        {
          value: this.filterValue,
          key: this.filterName,
          label: this.filterLabel || this.filterValue,
        },
      ]);
    }
    if (!this.filterValue && this.startDate != "" && this.endDate != "") {
      this.$root.$emit("filter:apply", [
        {
          value: this.startDate,
          key: "date_start",
          label: this.startDate,
        },
        {
          value: this.endDate,
          key: "date_end",
          label: this.endDate,
        },
      ]);
    }
    this.isOpen = false;
  }
}
